import { CircularProgress } from '@mui/material';
import React from 'react';
import { Skeleton, Box } from '@mui/material';

const Loader = () => {
    return (
        <div style=
            {{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: 'auto'
            }}>
            <CircularProgress sx={{height: 'auto !important', width: 'auto !important'}}/>
        </div>
    );
};

export default Loader;

export const WhatsNextLoader = ({ count }) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {Array.from({ length: count }).map((_, index) => (
        <Box key={index} display="flex" alignItems="center" gap={2}>
          <Skeleton
            variant="rectangular"
            width={100}
            height={100}
            animation="wave"
          />
          <Box display="flex" flexDirection="column" flexGrow={1} gap={1}>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={20}
              animation="wave"
            />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={50}
              animation="wave"
            />
            <Skeleton
              variant="rectangular"
              width="30%"
              height={20}
              animation="wave"
            />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export const VideoAndTutorialsLoader = ({ count }) => (
  <Box display="flex" flexDirection="column" gap={2}>
    {Array.from({ length: count }, (_, index) => (
      <Box
        key={index}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Skeleton
          variant="rectangular"
          width="60%"
          height={30}
          animation="wave"
        />
        <Skeleton
          variant="rectangular"
          sx={{ mr: 2 }}
          width={30}
          height={30}
          animation="wave"
        />
      </Box>
    ))}
  </Box>
);
